import { createSelector } from 'reselect';

const selectBankrateLeadProviderState = state => state.system.bankrateLeadProvider;

export const selectBankrateTokens = createSelector(
  selectBankrateLeadProviderState,
  state => state.tokens || [],
);

export const selectBankrateTokensLoading = createSelector(
  selectBankrateLeadProviderState,
  state => state.tokensLoading,
);

export const selectBankrateInboundLeads = createSelector(
  selectBankrateLeadProviderState,
  state => state.inboundLeads || null,
);

export const selectBankrateInboundLeadsLoading = createSelector(
  selectBankrateLeadProviderState,
  state => state.inboundLeadsLoading,
);

export const selectBankrateAggregates = createSelector(
  selectBankrateLeadProviderState,
  state => state.aggregates || null,
);
